import { useFacilityNavigation } from './use-facility-navigation';

export const useSingleFacilityUser = () => {
  const { facilitiesOptions } = useFacilityNavigation();
  const isSingleFacilityUser = facilitiesOptions?.length === 1;
  const singleFacility = isSingleFacilityUser ? facilitiesOptions![0] : null;
  return { isSingleFacilityUser, singleFacility };
};
